import registrationOtpDictionary from '@widgets/registration-otp/i18n/ru/registration-otp.dic.json';

export const registrationOtp = {
  REGISTRATION_OTP: registrationOtpDictionary,
};

export const registrationOtpNamespaces = ['REGISTRATION_OTP'];
